// This is an abstraction around how we can handle warnings that should be displayed indefinitely
// Currently it uses 'toaster' to display these warnings,
// but this could be modified to display them differently, if needed

(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').factory('PersistentWarningService', [
        '_',
        'StrConvert',
        'toaster',
        PersistentWarningService,
    ]);

    function PersistentWarningService(
        _,
        StrConvert,
        toaster
    ) {

        var warnings = {
            list: []
        };

        var service = {
            add: add,
            addOrReplace: addOrReplace,
            clear: clear,
            getAll: getAll,
            remove: remove,
        };

        return service;

        function clear() {
            _.forEach(warnings.list, function(warning) {
                toaster.clear(warning);
            });
            _.forEach(warnings, function(property){
                if (property.length){
                    return;
                }
                toaster.clear(property);
                if (property && property.message){
                    property.message = null;
                }
            });
        }

        function remove(warning, key) {
            if(!_.isNil(warning)) {
                if(_.isInteger(warning)) {
                    if(warning >= warnings.length) {
                        return;
                    }
                    warning = warnings.list[warning];
                }
                if (warning){
                    toaster.clear(warning);
                }
            }
            if (key) {
                warning = warnings[key];
                if (warning){
                    toaster.clear(warning);
                    warning.message = null;
                }
            }
        }

        function add(message, key) {
            message = StrConvert.replaceNewLine(message);
            var toast = toaster.pop({
                type: 'warning',
                body: message,
                title: '',
                timeout: 0,
                bodyOutputType: 'trustedHtml',
                onHideCallback: function() {
                    _.pull(warnings, toast);
                },
            });
            toast.message = message;
            if (key){
                warnings[key] = toast;
            } else {
                warnings.list.push(toast);
            }
            return toast;
        }

        function addOrReplace(message, key){
            var exist;
            message = StrConvert.replaceNewLine(message);

            if (key) {
                exist = warnings[key];
                if (exist && exist.message !== message){
                    remove(exist);
                    exist = null;
                }
            }           
            if (!exist){
                return add(message, key);
            }
            return exist;
        }

        function getAll(){
            return warnings;
        }
    }
})(window.angular);
